import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, Company } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function tasksTimesheet(activityPId, activity, projectP) {
    let url = 'timesheet/tasks?' + objectToQueryString({
        company: Company(),
        userCode: UserCode(),
        activityPId: activityPId,
        activity: activity,
        projectP: projectP,
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let tasks = response.tasks;

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortTasks(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.taskEn.toLowerCase() : a.taskFr.toLowerCase()
        const nameB = IsEnglish() ? b.taskEn.toLowerCase() : b.taskFr.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortTasksByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.taskCode
        const nameB = b.taskCode
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}